import { useEffect, useReducer } from 'react'
import { GET_NOTICELIST } from '../../api/AnnouncementApi'
import { history } from '../../redux/store'
import { userRouter } from '../../route'
import { GetLocalStorage, isResponseCodeSuccess } from '../../tools/util'
import reducer, {
  State,
  initState,
  setDataSourceAction,
  setLoadingAction,
  setPagesAction,
  setSearchDataAction,
} from './reducer'

const UseXhNoticeHook = () => {
  const [state, dispatch] = useReducer(reducer, initState)
  const supRoute = userRouter[1].url

  // 分页
  const onPageChange = (current: number, pagesize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: current,
        pageSize: pagesize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: current,
          pageSize: pagesize ? pagesize : 10,
        },
      },
    })
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchDataAction(params))
    getdata({
      ...state,
      ...{
        searchData: params,
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: State) => {
    dispatch(setLoadingAction(true))
    const params = { ...state.pages, ...state.searchData }
    const res = await GET_NOTICELIST({
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      rangType: GetLocalStorage('COOPERATETYPE'),
      title: params.announcementTitle,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: {
            data: resdata,
            total: count,
          },
          pageNo: res.data.pageNo,
        }),
      )
      dispatch(setLoadingAction(false))
    } else {
      dispatch(setLoadingAction(false))
    }
  }

  // 跳转详情
  const onDetail = (item?: any) => {
    history.replace({
      pathname: `${supRoute}/xhNoticeDetail`,
      state: {
        id: item.id,
      },
    })
  }

  useEffect(() => {
    getdata(state)
    // eslint-disable-next-line
  }, [])

  return {
    hookstate: state,
    onDetail,
    onPageChange,
    handleSearchClick,
  }
}
export default UseXhNoticeHook
import { useEffect, useReducer } from 'react'
import { GET_NOTICELIST } from '../../api/AnnouncementApi'
import { history } from '../../redux/store'
import { userRouter } from '../../route'
import { GetLocalStorage, isResponseCodeSuccess } from '../../tools/util'
import reducer, {
  State,
  initState,
  setDataSourceAction,
  setLoadingAction,
  setPagesAction,
  setSearchDataAction,
} from './reducer'

const UseXhNoticeHook = () => {
  const [state, dispatch] = useReducer(reducer, initState)
  const supRoute = userRouter[1].url

  // 分页
  const onPageChange = (current: number, pagesize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: current,
        pageSize: pagesize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: current,
          pageSize: pagesize ? pagesize : 10,
        },
      },
    })
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchDataAction(params))
    getdata({
      ...state,
      ...{
        searchData: params,
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: State) => {
    dispatch(setLoadingAction(true))
    const params = { ...state.pages, ...state.searchData }
    const res = await GET_NOTICELIST({
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      rangType: GetLocalStorage('COOPERATETYPE'),
      title: params.announcementTitle,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: {
            data: resdata,
            total: count,
          },
          pageNo: res.data.pageNo,
        }),
      )
      dispatch(setLoadingAction(false))
    } else {
      dispatch(setLoadingAction(false))
    }
  }

  // 跳转详情
  const onDetail = (item?: any) => {
    history.replace({
      pathname: `${supRoute}/xhNoticeDetail`,
      state: {
        id: item.id,
      },
    })
  }

  useEffect(() => {
    getdata(state)
    // eslint-disable-next-line
  }, [])

  return {
    hookstate: state,
    onDetail,
    onPageChange,
    handleSearchClick,
  }
}
export default UseXhNoticeHook
